<template>
  <div class="site-title">
    <a href="/" title="SCS Application Portal" aria-label="SCS Application Portal">
      <SiteLogoText />
    </a>
  </div>
</template>

<script setup>
import SiteLogoText from './SiteLogoText.vue'
</script>
